import { useDispatch, useSelector } from "react-redux";
import { getAppFeatures, makeSelectAppInited } from "../../../app/appSelectors";
import useWebSocket from "react-use-websocket";
import { FEATURES } from "../../../app/appConstants";
import { useEffect } from "react";
import {
    notificationsSlice,
    receiveNotificationMessageAction,
    setNotificationsWsReadyState,
    setNotificationsWsSendMessageFn,
} from '../notificationsReducer';
import pjson from "../../../../package.json";

export const useWssNotifications = () => {
    const features = useSelector(getAppFeatures);
    const isInited = useSelector(makeSelectAppInited());
    const dispatch = useDispatch();

    const {
        lastMessage,
        sendMessage,
        readyState,
        getWebSocket,
    } = useWebSocket(`${window.location.protocol === 'http:' ? 'ws' : 'wss'}://${window.location.host}/notifications-ws`, {
        shouldReconnect: () => true,
        queryParams: {
            "x-client-ver": pjson.version,
        }
    }, !!features[FEATURES.NOTIFICATIONS] && isInited);

    useEffect(() => {
        if (lastMessage !== null) {
            try {
                const data = JSON.parse(lastMessage.data);
                if (data.type) {
                    dispatch(receiveNotificationMessageAction(data));
                }
            } catch (e) {}
        }
    }, [dispatch, lastMessage]);

    useEffect(() => {
        dispatch(setNotificationsWsReadyState(readyState));
        dispatch(notificationsSlice.actions.setNotificationWebsocketInstanceAction(getWebSocket() as WebSocket))
    }, [dispatch, getWebSocket, readyState]);

    useEffect(() => {
        dispatch(setNotificationsWsSendMessageFn(sendMessage));
    }, [dispatch, sendMessage]);
}
